// extracted by mini-css-extract-plugin
export default {"slotsContainer":"Listing_slotsContainer__T+8+R"};